const translations = {
  // ── Sub Dashboard ──
  'sub.dashboard.title': 'マイワーク',
  'sub.dashboard.subcontractor': '下請け業者',
  'sub.dashboard.projectsCount': 'プロジェクト {count} 件',
  'sub.dashboard.instructionsCount': '指示 {count} 件',
  'sub.dashboard.assignedProjects': '担当プロジェクト',
  'sub.dashboard.noProjectsAssigned': '担当プロジェクトがありません',
  'sub.dashboard.noProjectsAssignedDesc': '現在、担当プロジェクトはありません。Japan Homesがプロジェクトを設定次第、ここに表示されます。',
  'sub.dashboard.instructions': '指示',
  'sub.dashboard.instructionsFromMgmt': '管理側から',
  'sub.dashboard.noActiveInstructions': '対応が必要な指示はありません',
  'sub.dashboard.actionRequired': '対応が必要です',
  'sub.dashboard.instructionsDueSoon': '期限間近の指示 {count} 件 — タップして確認',
  'sub.dashboard.subChecksPending': '下請けチェック対応待ち {count} 件',
  'sub.dashboard.tapToOpenChecklist': 'チェックリストを開く',
  'sub.dashboard.failedToLoad': 'プロジェクトの読み込みに失敗しました',
  'sub.dashboard.due': '期限',
  'sub.dashboard.stage': '段階',
  'sub.dashboard.backToDashboard': 'ダッシュボードに戻る',
  'sub.dashboard.viewAll': 'すべて見る',

  // ── Sub Daily Log ──
  'sub.dailyLog.title': '日次ログ',
  'sub.dailyLog.project': 'プロジェクト',
  'sub.dailyLog.allProjects': 'すべてのプロジェクト',
  'sub.dailyLog.photos': '写真',
  'sub.dailyLog.today': '今日',
  'sub.dailyLog.nonWorkingDay': '非稼働日',
  'sub.dailyLog.noAssignedProjects': '担当プロジェクトがありません',
  'sub.dailyLog.noAssignedProjectsDesc': 'アクティブなプロジェクト担当はありません。',

  // ── Sub Instructions ──
  'sub.instructions.title': '指示',
  'sub.instructions.management': '管理',
  'sub.instructions.subcontractor': '下請け',
  'sub.instructions.allProjects': 'すべてのプロジェクト',
  'sub.instructions.allStatus': 'すべてのステータス',
  'sub.instructions.open': '未対応',
  'sub.instructions.inReview': '確認中',
  'sub.instructions.resolved': '解決済み',
  'sub.instructions.instructions': '指示',
  'sub.instructions.responseRequired': '返答が必要',
  'sub.instructions.highPriority': '優先度: 高',
  'sub.instructions.due': '期限',
  'sub.instructions.overdue': '期限超過',
  'sub.instructions.reply': '返信',
  'sub.instructions.sendReply': '返信を送信',
  'sub.instructions.sending': '送信中...',
  'sub.instructions.progressUpdate': '進捗更新',
  'sub.instructions.question': '質問',
  'sub.instructions.issueReport': '問題報告',
  'sub.instructions.completed': '完了',
  'sub.instructions.acknowledge': '確認',
  'sub.instructions.markCompleted': '完了にする',
  'sub.instructions.cancel': 'キャンセル',
  'sub.instructions.attach': '添付',
  'sub.instructions.replySent': '返信を送信しました',
  'sub.instructions.readMore': 'もっと見る',
  'sub.instructions.showLess': '折りたたむ',
  'sub.instructions.noInstructions': '指示はまだありません',
  'sub.instructions.noInstructionsProject': '{project} の指示はまだありません。',
  'sub.instructions.allCaughtUp': '全て対応済みです',
  'sub.instructions.noInstructionsFilter': '{status} の指示はありません',
  'sub.instructions.unknownProject': '不明なプロジェクト',
  'sub.instructions.linkedItem': 'リンク項目',

  // ── Sub Instructions NEW keys ──
  'sub.instructions.project': 'プロジェクト',
  'sub.instructions.statusOpen': '未対応',
  'sub.instructions.statusInReview': '確認中',
  'sub.instructions.statusResolved': '解決済み',
  'sub.instructions.statusSent': '送信済み',
  'sub.instructions.statusCompleted': '完了',
  'sub.instructions.statusClosed': 'クローズ',
  'sub.instructions.priorityHigh': '高優先度',
  'sub.instructions.priorityMedium': '中優先度',
  'sub.instructions.priorityLow': '低優先度',
  'sub.instructions.acknowledged': '確認済み',
  'sub.instructions.replyCount': '{count} 件の返信',
  'sub.instructions.attachCount': '{count} 件添付',
  'sub.instructions.instructionCount': '指示 {count} 件',
  'sub.instructions.selectProjectFirst': '上でプロジェクトを選択してください。',
  'sub.instructions.noStatusInstructionsMsg': '{status} の指示はありません',
  'sub.instructions.replySentSuccess': '返信を送信しました',
  'sub.instructions.sendError': '返信の送信に失敗しました',
  'sub.instructions.authError': 'ログインが必要です',
  'sub.instructions.subcontractorRole': '下請け業者',
  'sub.instructions.justNow': 'たった今',
  'sub.instructions.minAgo': '{n} 分前',
  'sub.instructions.hrAgo': '{n} 時間前',
  'sub.instructions.hrsAgo': '{n} 時間前',
  'sub.instructions.dayAgo': '{n} 日前',
  'sub.instructions.daysAgo': '{n} 日前',
  'sub.instructions.dueDateLabel': '期限',
  'sub.instructions.today': '今日',
  'sub.instructions.yesterday': '昨日',

  // ── Sub Notifications ──
  'sub.notifications.title': '通知',
  'sub.notifications.all': 'すべて',
  'sub.notifications.unread': '未読',
  'sub.notifications.markAllRead': 'すべて既読にする',
  'sub.notifications.noNotifications': '通知はありません',
  'sub.notifications.noNotificationsDesc': '通知はここに表示されます',
  'sub.notifications.allCaughtUp': '全て確認済み!',
  'sub.notifications.noUnread': '未読の通知はありません',

  // ── Sub Project Detail ──
  'sub.project.overview': '概要',
  'sub.project.schedule': 'スケジュール',
  'sub.project.checklist': 'チェックリスト',
  'sub.project.files': 'ファイル',
  'sub.project.constructionJourney': '建築の旅',
  'sub.project.noStages': '段階はまだ設定されていません。',
  'sub.project.projectInfo': 'プロジェクト情報',
  'sub.project.site': '現場',
  'sub.project.startDate': '開始日',
  'sub.project.estCompletion': '完了予定日',
  'sub.project.recentUpdates': '最近の更新',
  'sub.project.activeInstructions': 'アクティブな指示',
  'sub.project.viewAll': 'すべて見る',
  'sub.project.dailyLog': '日次ログ',
  'sub.project.dailyLogDesc': '日付ごとに現場写真をアップロード',
  'sub.project.instructions': '指示',
  'sub.project.instructionsDesc': '管理側の要請を確認',
  'sub.project.backToDashboard': 'ダッシュボードに戻る',
  'sub.project.backToProject': '{project} に戻る',
  'sub.project.myChecklist': 'マイチェックリスト',
  'sub.project.pending': '対応待ち',
  'sub.project.awaitingYourCheck': 'あなたの確認を待っています',
  'sub.project.finalApproval': '最終承認',
  'sub.project.goToChecklist': 'チェックリストへ',
  'sub.project.pendingChecks': '下請けチェック対応待ち {count} 件',
  'sub.project.pendingChecksDesc': 'これらのチェックリスト項目はあなたの確認が必要です。管理側は既に確認済みです。以下のチェックリストタブをタップして確認を完了してください。',
  'sub.project.projectNotFound': 'プロジェクトが見つかりません',

  // ── Sub Stage Detail ──
  'sub.stage.stagePhotos': '段階の写真',
  'sub.stage.uploadPhoto': '写真をアップロード',
  'sub.stage.noPhotos': '写真はまだありません — タップしてアップロード',
  'sub.stage.stageUpdates': '段階の更新',
  'sub.stage.postUpdate': '更新を投稿',
  'sub.stage.postUpdateTitle': '更新を投稿',
  'sub.stage.describeUpdate': '現場での状況を記述してください...',
  'sub.stage.myChecklistItems': 'マイチェックリスト項目',
  'sub.stage.pending': '対応待ち',
  'sub.stage.check': '確認',
  'sub.stage.completed': '完了',
  'sub.stage.subcontractorCheckProgress': '下請けチェック進捗',
  'sub.stage.backToProject': '{project} に戻る',
  'sub.stage.noScheduledStage': '予定された段階はありません',
  'sub.stage.noScheduledStageNonWork': 'これは非稼働日です。',
  'sub.stage.noScheduledStageFound': 'この日付に予定された段階はありません。',
  'sub.stage.inProgress': '進行中',
  'sub.stage.stageProgress': '段階の進捗',
  'sub.stage.noPhotosYet': '写真はまだありません',
  'sub.stage.uploadPhotosForDay': '上からこの日の写真をアップロード',
  'sub.stage.savePhotos': '写真を保存',
  'sub.stage.saving': '保存中...',
  'sub.stage.photoUploaded': '写真をアップロードしました',
  'sub.stage.project': 'プロジェクト',
  'sub.stage.scheduledStage': '予定された段階',
  'sub.stage.uploadPhotos': '写真をアップロード',
  'sub.stage.dragDrop': 'ここに写真をドラッグ&ドロップ',
  'sub.stage.orTapBelow': 'または以下のボタンをタップ',
  'sub.stage.gallery': 'ギャラリー',
  'sub.stage.camera': 'カメラ',
  'sub.stage.pendingUploads': '保留中のアップロード',
  'sub.stage.clearAll': 'すべてクリア',
  'sub.stage.photosForThisDay': 'この日の写真',
  'sub.stage.noPhotosYetUpload': '写真はまだありません',
  'sub.stage.readyToUpload': '{count} 件 アップロード準備完了',
  'sub.stage.noPendingUploads': '保留中のアップロードはありません',
  'sub.stage.selectProjectFirst': 'アップロードする前に、上で特定のプロジェクトを選択してください。',
  'sub.stage.uploadDisabled': 'アップロード不可',
  'sub.stage.uploadDisabledNonWork': '非稼働日は写真アップロードはできません。',
  'sub.stage.nonWorkingDay': '非稼働日',
  'sub.stage.uploadNotAvailable': '写真アップロードは無効です。',
  'sub.stage.updatesWillAppear': '更新を投稿するとここに表示されます',
  'sub.stage.addPhoto': '写真を追加',

  // ── Common Sub Labels ──
  'sub.common.progress': '進捗',
  'sub.common.noDatesSet': '日付未設定',
  'sub.common.itemsCompleted': '{done}/{total} 項目完了',

  // ── Calendar month/weekday labels ──
  'sub.calendar.january': '1月',
  'sub.calendar.february': '2月',
  'sub.calendar.march': '3月',
  'sub.calendar.april': '4月',
  'sub.calendar.may': '5月',
  'sub.calendar.june': '6月',
  'sub.calendar.july': '7月',
  'sub.calendar.august': '8月',
  'sub.calendar.september': '9月',
  'sub.calendar.october': '10月',
  'sub.calendar.november': '11月',
  'sub.calendar.december': '12月',
  'sub.calendar.sun': '日',
  'sub.calendar.mon': '月',
  'sub.calendar.tue': '火',
  'sub.calendar.wed': '水',
  'sub.calendar.thu': '木',
  'sub.calendar.fri': '金',
  'sub.calendar.sat': '土',

  // ── Daily Log UI strings ──
  'sub.dailyLog.project': 'プロジェクト',
  'sub.dailyLog.selectProject': '日次ログを表示・送信するには、上でプロジェクトを選択してください。',
  'sub.dailyLog.loadingStatus': 'プロジェクトステータスを読み込み中…',
  'sub.dailyLog.projectProgress': 'プロジェクト進捗',
  'sub.dailyLog.scheduleFinal': 'スケジュール最終',
  'sub.dailyLog.checklistFinal': 'チェックリスト最終',
  'sub.dailyLog.complete': '% 完了',
  'sub.dailyLog.todayBtn': '今日',
  'sub.dailyLog.completedBadge': '完了',
  'sub.dailyLog.pendingReview': 'レビュー待ち',
  'sub.dailyLog.approved': '承認済み',
  'sub.dailyLog.rejected': '却下',
  'sub.dailyLog.internalOnly': '内部のみ',
  'sub.dailyLog.mixed': '混在',
  'sub.dailyLog.submittedBadge': '提出済',
  'sub.dailyLog.logCountBadge': '{count}件',
  'sub.dailyLog.photoCountBadge': '写真{count}枚',
  'sub.dailyLog.onePhotoBadge': '写真1枚',
  'sub.dailyLog.loadErrorTitle': '日報を読み込めませんでした',
  'sub.dailyLog.retryLoad': '再試行',
  'sub.dailyLog.noAssignedProjectsLong': '担当プロジェクトがありません',
  'sub.dailyLog.noAssignedProjectsLongDesc': 'アクティブなプロジェクト担当はありません。',
  'sub.dailyLog.selectProjectTitle': 'プロジェクトを選択',
  'sub.dailyLog.selectProjectDesc': '日次ログを表示・送信するには、上でプロジェクトを選択してください。',
  'sub.dailyLog.noPhotos': '写真',

  // ── Dashboard status labels ──
  'sub.dashboard.statusOpen': '未対応',
  'sub.dashboard.statusInReview': '確認中',
  'sub.dashboard.statusResolved': '解決済み',
  'sub.dashboard.statusCompleted': '完了',
  'sub.dashboard.overdue': '期限超過',
  'sub.dashboard.dueToday': '本日期限',
  'sub.dashboard.dueTomorrow': '明日期限',
  'sub.dashboard.dueSoon': '期限: {date}',
  'sub.dashboard.instructionsTitle': '指示',
  'sub.dashboard.unknownProject': '不明なプロジェクト',
  'sub.dashboard.failedToLoadProjects': 'プロジェクトの読み込みに失敗しました',

  // ── Project page strings ──
  'sub.project.backToDashboard2': 'ダッシュボードに戻る',
  'sub.project.datesTBC': '日付未定',
  'sub.project.tbc': '未定',
  'sub.project.datesRange': '{start} — {end}',
  'sub.project.completedLabel': '完了',
  'sub.project.inProgressLabel': '進行中',
  'sub.project.upcomingLabel': '予定',
  'sub.project.delayedLabel': '遅延',
  'sub.project.onHoldLabel': '保留',
  'sub.project.generalUpdate': '一般',
  'sub.project.pendingChecksDesc': 'これらのチェックリスト項目はあなたの確認が必要です。管理側は既に確認済みです。以下のチェックリストタブをタップして確認を完了してください。',
  'sub.project.dailyLogDesc2': '日付ごとに現場写真をアップロード',
  'sub.project.instructionsDesc2': '管理側の要請を確認',

  // ── Stage page strings ──
  'sub.stage.mgmtDone': '管理: 完了',
  'sub.stage.mgmtPending': '管理: 保留中',
  'sub.stage.subPending': '下請: 保留中',
  'sub.stage.subDone': '下請: 完了',
  'sub.stage.finalComplete': '最終: 完了',
  'sub.stage.waitingForSubcontractor': '下請業者待ち',
  'sub.stage.checkLabel': '確認',
  'sub.stage.progressTag': '進捗',
  'sub.stage.issueTag': '問題',
  'sub.stage.completeTag': '完了',
  'sub.stage.backToProjectShort': '{project} に戻る',
  'sub.stage.stageNotFound': '段階が見つかりません',
  'sub.stage.photoUploadedSuccess': '写真をアップロードしました',
  'sub.stage.doneCount': '{completed}/{total} 完了',
};

export default translations;